import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FlagComponent } from '@repo/ui/phone-input'
import Typography from '@repo/ui/typography'

import { getCountryCodeFromPhoneNumber } from '../../lib/utils/functions/get-country-code-from-phone-number'
import { formatPhoneNumber } from '../../utils/functions/format-phone-number'

type Props = {
  phoneNumber: string
}

const PhoneNumberDisplay = ({ phoneNumber }: Props) => {
  const countryCode = getCountryCodeFromPhoneNumber(phoneNumber)
  return (
    <div className="flex items-center gap-0">
      {countryCode && <FlagComponent shape="rounded" country={countryCode} countryName="" />}
      <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
        {formatPhoneNumber(phoneNumber)}
      </Typography>
    </div>
  )
}

export default PhoneNumberDisplay
